// @ts-nocheck
import { addToChainBefore } from "@toolkit/Modules/client-framework/HandlerCreator";
import {
    chain,
    LoadRealTimePrices,
} from "@insite/client-framework/Store/Components/ProductInfoList/Handlers/LoadProductInfoList";
import { ExtractHandlerParameter, ExtractHandlerProps } from "@store/Framework/Types/Common";

type HandlerChainType = typeof LoadRealTimePrices;

export interface LoadProductInfoListParameter extends ExtractHandlerParameter<HandlerChainType> {
    warehouse?: string;
}

export interface LoadProductInfoListProps extends ExtractHandlerProps<HandlerChainType> {}

addToChainBefore<LoadProductInfoListParameter, LoadProductInfoListProps>(chain, LoadRealTimePrices, props => {
    if (!props.parameter.warehouse || !props.productInfos?.length) {
        return;
    }

    props.productInfos = props.productInfos.map(productInfo => ({
        ...productInfo,
        properties: {
            PricingWarehouseOverride: props.parameter.warehouse,
        },
    }));
});
